import Api from "../../config/api";
import {
  CHANGED_PASSWORD,
  CREATE_USER,
  DELETE_USER_FILE_BY_ID,
  SEARCH_USER,
  SEARCH_USER_BY_ID,
  UPDATE_USER,
  UPLOAD_MANY_USER_FILE,
  UPLOAD_USER_FILE,
} from "../../utils/constants";
import { showToast } from "../toast/ShowToast";

export const getUser = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_USER, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getUserById = async (id?: string | null, params?: any) => {
  try {
    const res = await Api(false).get(`${SEARCH_USER_BY_ID}/${id}`, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createUser = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_USER, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateUser = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_USER}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const changedPassword = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(true).put(
      `${CHANGED_PASSWORD}/${id}/password/change`,
      body
    );
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const uploadFile = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(true).post(UPLOAD_USER_FILE, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const deleteFile = async (id: string, hideLoader: () => void) => {
  try {
    const res = await Api(true).delete(`${DELETE_USER_FILE_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const uploadFileMany = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(true).post(UPLOAD_MANY_USER_FILE, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
